import { v4 as uuidv4 } from "uuid";

import {
  type ClientActivityReporter,
  createClientActivityReporter,
} from "./clientActivityReporter";
import type { ClientActivityDetails, ClientActivitySend, ClientActivityType } from "./types";
import { resetViewedCards } from "./viewedCards";

export interface ClientActivityConfig {
  send: ClientActivitySend;
  platformId: string;
  isAuthenticated: () => boolean;
}

const deviceStorage = {
  getItem: (key: string) => window.localStorage.getItem(key),
  setItem: (key: string, value: string) => window.localStorage.setItem(key, value),
  removeItem: (key: string) => window.localStorage.removeItem(key),
};

let reporter: ClientActivityReporter | null = null;
let hideListenersRegistered = false;

function logClientActivityError(error: unknown): void {
  console.error("[ClientActivity]", error);
}

function flushOnHide(): void {
  void reporter?.flush({ keepalive: true });
}

function registerHideListeners(): void {
  if (hideListenersRegistered) return;
  hideListenersRegistered = true;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushOnHide();
  });
  window.addEventListener("pagehide", flushOnHide);
}

export function configureClientActivity(config: ClientActivityConfig): void {
  reporter = createClientActivityReporter({
    ...config,
    now: () => new Date(),
    storage: deviceStorage,
    newId: uuidv4,
    onError: logClientActivityError,
    onSessionStart: resetViewedCards,
  });
  registerHideListeners();
}

export function reportClientActivity(
  type: ClientActivityType,
  details: ClientActivityDetails = {},
): void {
  if (reporter === null) {
    logClientActivityError(new Error(`Client activity ${type} reported before configuration`));
    return;
  }
  reporter.record(type, details);
}

export function flushClientActivity(): Promise<void> {
  return reporter === null ? Promise.resolve() : reporter.flush({ keepalive: false });
}
